import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
// Generated design tokens (CSS custom properties) must load before component styles.
import './generated/theme/tokens.css';
import './index.css';
import { AppProviders } from './app/providers';
import { appSurface } from './lib/backend/config';
import { createAppRouter } from './app/router';

document.title = appSurface === 'portal' ? 'AABAR Center' : 'AABAR Admin';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

void createAppRouter()
  .then((router) => {
    createRoot(rootEl).render(
      <StrictMode>
        <AppProviders>
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </AppProviders>
      </StrictMode>,
    );
  })
  .catch((err: unknown) => {
    // A failed route-chunk import (e.g. a stale deploy, or a flaky network on first load) must not
    // leave a blank page — this is the last resort before any UI, including i18n, is available.
    console.error('Failed to load the app router', err);
    rootEl.textContent = 'Something went wrong loading the app. Please reload.';
  });
